import React from 'react';
import Radio, { RadioProps } from '@mui/material/Radio';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { makeStyles } from '@mui/styles';

// Define the type for props
interface CustomRadioProps extends RadioProps {
    selected: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
}

// Custom styles for the Radio component
const useStyles = makeStyles({
    uncheckedIcon: {
        fill: '#313233 !important',
    },
    checkedIcon: {
        fill: '#00D1A8 !important',
    },
});

// Custom Radio component
const RadioButton: React.FC<CustomRadioProps> = ({ selected, onChange, label, ...props }) => {
    const classes = useStyles();
    return (
        <Radio
            checked={selected}
            onChange={onChange}
            icon={<RadioButtonUncheckedIcon className={classes.uncheckedIcon} />}
            checkedIcon={<CheckCircleIcon className={classes.checkedIcon} />}
            {...props}
        />
    );
};

export default RadioButton;
